
import { WorldCountry } from '../types';
import { finlandExpanded } from './finlandExpansion';
import { denmarkExpanded } from './denmarkExpansion';

export const finalEuropeCountries5: WorldCountry[] = [
  finlandExpanded,
  denmarkExpanded
];
